import * as Sentry from '@sentry/react';
import React, { FunctionComponent, ReactNode, Suspense, lazy, useCallback } from 'react';

import { dynamicImport } from '@canvas/dynamic-import';

export interface FatalErrorProps {
  error: Error;
}

export interface ErrorBoundaryProps {
  children: ReactNode;
}

const DatabaseFatalError = lazy(() =>
  dynamicImport(() => import('./DatabaseFatalError'))
);

const ErrorBoundary: FunctionComponent<ErrorBoundaryProps> = ({ children }) => {
  const fallback: Sentry.FallbackRender = useCallback(
    ({ error }) => (
      <Suspense>
        <DatabaseFatalError error={error} />
      </Suspense>
    ),
    []
  );

  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setLevel('fatal');
      }}
      fallback={fallback}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
